import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { storageTextObj } from '@components/helpers/ObjectsText';
import { StringSmall } from '@components/Typography/Typography';
import { Picture } from '@components/ui/Picture/Picture';

import { AppRoute } from '@/common/app/routes';
import { getImage } from '@/common/lib/images';

import css from './styles.module.scss';

interface GoodsNavigationItemProps {
  id: string;
  goodsName: string;
  onClose: () => void;
}

const GoodsNavigationItem: FC<GoodsNavigationItemProps> = ({
  id,
  goodsName,
  onClose,
}) => {
  const { t } = useTranslation();
  const { id: pageId } = useParams();
  const navigate = useNavigate();
  const texts = storageTextObj(t);

  const goodsImage = getImage({ name: goodsName, field: 'icon' });

  const onClick = (): void => {
    if (pageId !== id) {
      navigate(AppRoute.WORKSHOP + `/${id}`, {
        state: { goodsName, value: 1 },
      });
      onClose();
    }
  };

  return (
    <div onClick={onClick} className={css.plantNavItem}>
      <StringSmall weight="medium" className={css.label}>
        {texts[goodsName]}
      </StringSmall>
      <Picture
        className="w-10 h-10 shrink-0"
        img={goodsImage?.img}
        webp={goodsImage?.webp}
        alt={goodsName}
      />
    </div>
  );
};

export { GoodsNavigationItem };
